import { ASPExperiment } from 'shared/experiments/ASPSearch/ASPExperiment'

export enum BOOST_VARIATIONS {
  Control = 'BoostControl',
  Enabled = 'BoostEnabled',
}

export const MIN_RELEVANT_BOOST_COUNT = 2
export const MAX_BOOST_TERMS = 25

export enum TEMPLATE_INTERACTION_TYPE {
  QUICKVIEW = 'QuickView',
  QUICKVIEW_QSP = 'QuickViewQSP',
  STUDIO_TRANSITION = 'StudioTransition',
}

export const RELEVANT_BOOST_TYPES = [TEMPLATE_INTERACTION_TYPE.QUICKVIEW, TEMPLATE_INTERACTION_TYPE.QUICKVIEW_QSP, TEMPLATE_INTERACTION_TYPE.STUDIO_TRANSITION]

export enum TEMPLATE_INTERACTION_SUBTYPE {
  KEYWORD = 'keyword',
  CATEGORY = 'category',
}

const BoostExplorationExperiment = {
  experimentKey: 'boost_exploration',
  variationsValueMap: {
    [BOOST_VARIATIONS.Enabled]: '0.2',
    [BOOST_VARIATIONS.Control]: '0',
  },
} as ASPExperiment

const BoostCoefficientExperiment = {
  experimentKey: 'boost_coefficient',
  variationsValueMap: {
    [BOOST_VARIATIONS.Enabled]: '0.8',
    [BOOST_VARIATIONS.Control]: '0',
  },
} as ASPExperiment

const BoostLimitParttExperiment = {
  experimentKey: 'boost_limit_part',
  variationsValueMap: {
    [BOOST_VARIATIONS.Enabled]: '0.05',
    [BOOST_VARIATIONS.Control]: '0',
  },
} as ASPExperiment

export const BoostingASPExperiments = [BoostExplorationExperiment, BoostCoefficientExperiment, BoostLimitParttExperiment]

export const BOOST_EXPERIMENT_NAME = 'gallery_boosting_on_template_interaction'
